import MapTransform from '@app/transforms/MapTransform';
import IOfferSlideData from '@app/types/data/slides/IOfferSlideData';
import ISlideMaster from '@app/types/presentations/master/ISlideMaster';
import IPresentationSettings from '@app/types/presentations/presentation/IPresentationSettings';
import AbstractSlideTransform from './AbstractSlideTransform';

export default abstract class AbstractOfferSlideTransform extends AbstractSlideTransform {
	public async transform(slide: ISlideMaster, presentationSettings: IPresentationSettings): Promise<IOfferSlideData> {
		const data: IOfferSlideData = {
			id: slide.id,
			label: slide.fields.label || slide.fields.headline,
			shareViewSection: slide.fields.shareViewSection === 'special-info' ? 'special-info' : undefined,
			headline: slide.fields.headline,
			copy: this.transformRichtext(slide.fields.copy, presentationSettings),
			// prefer new footnoteRef schema, fallback to directly configured footnote if no ref is set
			// @see https://jungfrau.atlassian.net/browse/SALESAPP-1592
			footnote:
				slide.fields.footnoteRef && slide.fields.footnoteRef.fields.text
					? slide.fields.footnoteRef.fields.text
					: undefined,
			thumbnail: this.extractThumbnail(slide.fields.headline, slide, 'image'),
			image: this.transformImageAsset(slide.fields.image?.fields.asset ?? this.getFallbackImage(), {
				width: 5000,
				height: 5000,
				crop: 'limit'
			}),
			map: slide.fields.map ? MapTransform.getSvg(slide.fields.map) : undefined,
			mapLabels: AbstractSlideTransform.getMapLabels(),
			elevation: slide.fields.elevation,
			operatingTimes: AbstractSlideTransform.parseObjectWithOperatingTimes(slide),
			priceValidity: slide.fields.priceValidity,
			offerValidity: slide.fields.offerValidity,
			badgeText: slide.fields.badgeText
		};

		return data;
	}
}
